import React from 'react';
import './Hero.css';

const Hero = () => {
  return (
    <section className="hero">
      <div className="container">
        <div className="hero-content">
          <div className="hero-text">
            <h1>Start Your Recovery Journey With Expert Care</h1>
            <h2>With Physero's Personalised Physiotherapy Treatment At Home</h2>
            <p className="hero-subtitle">Say goodbye to pain and hello to relief</p>

            <div className="hero-stats">
              <div className="stat-item">
                <h3>2000+</h3>
                <p>Physiotherapists</p>
              </div>
              <div className="stat-item">
                <h3>4.8</h3>
                <p>Google Rating</p>
              </div>
            </div>

            <div className="hero-actions">
              {/* <button className="btn-primary btn-large">Book Now</button> */}
              {/* <button className="btn-secondary btn-large">Learn More</button> */}
            </div>
          </div>

          <div className="hero-image">
            <img src="/assets/images/hero-physiotherapist.png" alt="Professional Physiotherapist" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;